import {
    getAxios,
    formDataToRequestParams,
//    getRequest
} from './axios'

import {
    responseResolveInterceptor
} from './interceptors';

export function recoverPassword(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/password_recover/send.php',
        method: 'post',
        data: formDataToRequestParams(data)
    });
}

export function changePassword(data) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/password_recover/change.php',
        method: 'post',
        data: formDataToRequestParams(data)
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/passwordRecover.js